<template>
    <div>
        <div class="wrapper">
            <header>
                <div class="logo-box">
                    <router-link :to="{name: 'Home'}">
                        <img src="~img/logo-white.png" alt="">
                    </router-link>
                </div>
            </header>
            <div class="content-box">
                <div class="title">Jau netrukus</div>
                <div class="subtitle">Modernus e-užsakymų vykdymas verslo augimui</div>
                <div class="form-wrapper">
                    <i class="icon-envelope-alt"></i>
                    <form class="form-inline">
                        <div class="form-group">
                            <label for="email" class="sr-only">email</label>
                            <input type="password" class="form-control" id="email" placeholder="peliukai@gmail.co|">
                        </div>
                        <button type="submit" class="btn btn-blue">gauti naujienas</button>
                    </form>
                    <div class="form-wrapper_text">Gauk informaciją pirmas ir niekada nebūsi paskutinis sužinojęs apie modernų
                    e-užsakymų vykdymą
                    </div>
                </div>
            </div>
        </div>
        <footer>
            <div class="bg-transparent">
                <div class="container">
                    <div class="footer-bottom-row">
                        <div class="mr-auto">info@boxiti.lt</div>
                        <div class="ml-auto">Visos teisės saugomos © 2016 boxiti</div>
                    </div>
                </div>
            </div>
        </footer><!-- End Footer -->
    </div>
</template>

<script>
    export default {
        name: 'ComingSoon',
        beforeRouteEnter(from, to, next) {
            next((vm) => vm.$store.dispatch('changeStylesSpecialPage', 'coming-soon'))
        },
        beforeRouteLeave(from, to, next) {
            this.$store.dispatch('changeStylesSpecialPage', '').then(() => next())
        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/components/Public/ComingSoon.vue